import { Link } from "react-router-dom";
import { ScanSearch, MessageSquareText, Wrench } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { IMG } from "@/lib/catalog";

const STEPS = [
  { icon: ScanSearch, t: "Diagnóstico", d: "Revisamos suspensión, dirección y frenos para encontrar el origen real del ruido o la falla." },
  { icon: MessageSquareText, t: "Explicación y cotización", d: "Te mostramos lo que encontramos y te cotizamos piezas y mano de obra antes de trabajar." },
  { icon: Wrench, t: "Reparación", d: "Realizamos el trabajo autorizado y te entregamos tu vehículo listo para rodar." },
];

export default function About() {
  useSeo("Nosotros", "Conoce al Taller de Suspensiones La Gringa en Mérida: especialistas en suspensión y dirección.");
  return (
    <>
      <PageHero eyebrow="Nosotros" title="Un taller enfocado en lo que mejor sabe hacer" image={IMG.garage}
        subtitle="En La Gringa nos especializamos en suspensión delantera, trasera y dirección. Esa especialidad nos permite diagnosticar con precisión y reparar solo lo necesario." />
      <section className="container-x grid gap-12 py-24 lg:grid-cols-2 items-center">
        <img src={IMG.bay} alt="Vehículo en el área de trabajo del taller" className="h-[520px] w-full rounded-md object-cover" loading="lazy" />
        <div>
          <p className="eyebrow">Cómo trabajamos</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold uppercase">Claridad de principio a fin</h2>
          <ol className="mt-10 space-y-8">
            {STEPS.map((s, i) => (
              <li key={s.t} className="flex gap-5">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-sm border border-brand/40 bg-green font-display text-xl font-bold text-gold">{i + 1}</span>
                <div>
                  <h3 className="flex items-center gap-2 text-xl font-semibold uppercase"><s.icon size={18} className="text-brand" /> {s.t}</h3>
                  <p className="mt-1 text-mute">{s.d}</p>
                </div>
              </li>
            ))}
          </ol>
          <Link to="/citas" className="btn-gold mt-10" data-testid="about-book-btn">Agenda tu diagnóstico</Link>
        </div>
      </section>
    </>
  );
}
